import { Injectable } from '@angular/core';
import _ from 'lodash';

@Injectable({
  providedIn: 'root'
})
export class VariablesService {
  constructor() {}

  test = 'test';

  VARIABLE = {
    REGCODE: { ID: 2000 },
    varBenefitLevel:{
      ID:52
    },
    WEALTH_MANAGEMENT_FIRM: {
      ID: 46,
      displayOnSummary: true,
    },
    WEALTH_MANAGEMENT_FIRM_LEVEL: {
      ID: 47,
      displayOnSummary: true,
    },
    CFP: {
      ID: 48,
      displayOnSummary: true,
    },
    varCRDNumber: {
      ID: 49,
      displayOnSummary: true,
    },
    FIELD_MANAGER: {
      ID: 50,
      displayOnSummary: true,
    },
    OSJ: {
      ID: 51,
      displayOnSummary: true,
    },
    PHOTO_RELEASE: {
      ID: 41,
      displayOnSummary: true,
    },
    HARASSMENT_POLICY: {
      ID: 40,
      displayOnSummary: true,
    },
    DEPARTMENT_NAME: {
      ID: 45,
      displayOnSummary: true,
    },
    NEURODIVERSITY: {
      ID: 18,
      displayOnSummary: true,
    }, 
    ADVISORY_BOARD: {
      ID: 17,
      displayOnSummary: true,
    },
    LANG_INTERP: {
      ID: 9,
      displayOnSummary: true,
    },
    DONATION: {
      ID: 42,
      displayOnSummary: true,
    },
    GUEST_CITY: {
      ID: 15,
      displayOnSummary: true,
    },
    GUEST_STATE: {
      ID: 16,
      displayOnSummary: true,
    },
    FIRST_TIME: {
      ID: 19,
    },
    AGE: {
      ID: 20,
      displayOnSummary: true
    },
    GENDER: {
      ID: 21,
      displayOnSummary: true
    },
    ETHNICITY: {
      ID: 22,
      displayOnSummary: true
    },
    BIZJOB: {
      ID: 23,
      displayOnSummary: true
    },
    EMPLOYEENUMS: {
      ID: 24,
      displayOnSummary: true
    },
    EXP: {
      ID: 25,
      displayOnSummary: true
    },
    AUM: {
      ID: 26,
      displayOnSummary: true
    },
    AFFILIATION: {
      ID: 27,
      displayOnSummary: true
    },
    ISALT: {
      ID: 28,
      displayOnSummary: true
    },
    ISBUF: {
      ID: 29,
      displayOnSummary: true
    },
    ISEMP: {
      ID: 30,
      displayOnSummary: true
    },
    ISETF: {
      ID: 31,
      displayOnSummary: true
    },
    ISNET: {
      ID: 32,
      displayOnSummary: true
    },
    ISMODEL: {
      ID: 33,
      displayOnSummary: true
    },
    ISSMA: {
      ID: 34,
      displayOnSummary: true
    },
    AIV: {
      ID: 35,
      displayOnSummary: true
    },
    SMA: {
      ID: 36,
      displayOnSummary: true
    },
    BREAKOUT: {
      ID: 37,
      displayOnSummary: true
    },
    CE: {
      ID: 38,
      displayOnSummary: true
    },
    DCCONTACT: {
      ID: 39,
      displayOnSummary: true
    },
    BRAINDATE: {
      ID: 43,
      displayOnSummary: true
    },
    BEDDING: {
      ID: 10,
      displayOnSummary: true
    },
    ROOMMATE: {
      ID: 11,
      displayOnSummary: true
    },
    ROOMMATEEMAIL: {
      ID: 12,
      displayOnSummary: true
    },
    ROOMMATEARRIVE: {
      ID: 13,
      displayOnSummary: true
    },
    ROOMMATEDEPART: {
      ID: 14,
      displayOnSummary: true
    },



    EXTENSION: { ID: 55 },
    EXTENSION_OPTIONS: { ID: 56 },
    OTHER_NUMBER: { ID: 72 }
    // NO_HOTEL_REASON: {ID: 2, summaryDisplayLabel: "nohotellabel", displayOnSummary:true, page:"hotel"}
  };

  toCheckBoxModel(actual, keys, delimiters?) {
    if (!keys) {
      return undefined;
    }
    const model = {};
    if (!actual) {
      return model;
    }
    const split = actual.split(delimiters ? delimiters : /,+ */);
    return _.values(keys).reduce((a, c) => {
      a[c] = split.indexOf(c) >= 0;
      return a;
    }, model);
  }

  toDelimitedKeysString(c, delimiters?) {
    if (!c) {
      return '';
    }
    return _.keys(c)
      .filter(k => {
        return c[k];
      })
      .join(delimiters ? delimiters : ', ');
  }
}
